$('nav').slideAndSwipe();